/*
 * Honest not-wired click signal (Duncan review fix 2, BOARDROOM-2026-08-03-100121).
 * Inert controls must never read as "broken": any tap on an unwired action
 * shows this toast instead of doing nothing. No flows are fabricated
 * (PROGRAMME-AD-NO-FABRICATED-DATA-IN-BUILDS-V1 holds).
 */

const TOAST_ID = 'notwired-toast'
let hideTimer: number | undefined

export const NOT_WIRED_MESSAGE = 'Not available yet — this action isn’t wired to a live service.'

export function showNotWiredToast(message: string = NOT_WIRED_MESSAGE): void {
  let el = document.getElementById(TOAST_ID)
  if (!el) {
    el = document.createElement('div')
    el.id = TOAST_ID
    el.setAttribute('role', 'status')
    el.setAttribute('aria-live', 'polite')
    el.setAttribute('data-wired', 'false')
    el.style.cssText = [
      'position:fixed',
      'left:50%',
      'bottom:calc(24px + env(safe-area-inset-bottom))',
      'transform:translateX(-50%)',
      'max-width:min(420px, calc(100vw - 32px))',
      'padding:10px 16px',
      'border-radius:999px',
      'border:1px solid var(--warn, #e6c15a)',
      'background:var(--surface, #171c1f)',
      'color:var(--warn, #e6c15a)',
      'font-size:12px',
      'font-weight:600',
      'text-align:center',
      'z-index:300',
      'box-shadow:0 6px 24px rgba(0,0,0,0.45)',
      'transition:opacity .2s',
    ].join(';')
    document.body.appendChild(el)
  }
  el.textContent = message
  el.style.opacity = '1'
  if (hideTimer) window.clearTimeout(hideTimer)
  hideTimer = window.setTimeout(() => {
    const node = document.getElementById(TOAST_ID)
    if (node) {
      node.style.opacity = '0'
      window.setTimeout(() => node.remove(), 250)
    }
  }, 2600)
}
